<template>
  <div>
    <div class="twui-header xdoc xconsole">
      <div class="twui-header-inner" id="header">
        <h1 class="tw-header-left">
          <router-link to="/" class="twui-header-logo">
            <img :src="orgLogo" />
          </router-link>
          <span class="tw-header-title">{{$t('m.platform_name')}}</span>
        </h1>
        <div :style="{visibility:isShowMenuLis ? 'visible':'hidden'}" v-for="(item,index) in menuList" :key="index">
          <div class="twui-header-nav">
            <el-dropdown v-if="item.menuId === 'TWPAAS11000000003'" @command="jumpTo">
              <span class="xrouter">{{item.menuName}}</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0" style="text-align:left">{{$t('m.twtymyapi')}}</el-dropdown-item>
                <el-dropdown-item command="1" style="text-align:left">{{$t('m.twzjk')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="text" :class="activeMenuId===item.menuId?'xactice-color':'xbutton-color'" v-else @click="getMenuList (item.menuId)">{{item.menuName}}</el-button>
          </div>
        </div>

        <div class="twui-header-right" v-show="showUserImg">
          <el-button type="text" v-if="showDocMMneu" class="xbutton-color" @click="goto">{{$t('m.document_menu_management')}}</el-button>
          <tw-lang ref="twlang"></tw-lang>
          <div class="twui-header-userbox xadmin">
            <img src="../static/images/nav-headportrait.png" :alt="$t('m.yhtx')" />
            <div class="twui-header-usermenu">
              <div class="xhead">
                <img src="../static/images/nav-headportrait.png":alt="$t('m.yhtx')" />
                <span :class="{xno:!(orgName != null && orgName != 'null' && orgName != 'undefined')}">{{username}}</span>
                <span class="xinfo">{{ orgName != null && orgName != 'null' && orgName != 'undefined' ? orgName : '' }}</span>
              </div>
              <a @click="logout">
                <i class="twui-ico xoff"></i>
                {{$t('m.logout')}}
              </a>
            </div>
          </div>
        </div>
        <div class="twui-header-right" v-show="!showUserImg">
          <a @click="showLogin()">{{$t('m.login')}}</a>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import utils from '@/config/cookieUtils'
import TwLang from './tw-lang'
// let CryptoJS = require('crypto-js')
let headConfig = {
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
}
export default {
  name: 'TwHeader',
  components: { TwLang },
  data () {
    return {
      routePath: '',
      activeMenuId: '',
      showDocMMneu: false,
      appList: [],
      appTypeDocList: [],
      menuList: [],
      showMenuLis: null,
      isShowMenuLis: false,
      orgName: '',
      username: '',
      minHeight: 0,
      showCaptcha: false,
      chooseOrg: false,
      autoLogin: false,
      dialogLogin: false,
      showUserImg: false,
      loginUser: null,
      passwd: null,
      userId: null,
      captcha: null,
      CAPTCHA_IMG: null,
      CAPTCHA_TEXT: null,
      orgList: [],
      hasUserOrg: true,
      user: {}
    }
  },
  computed: {
    orgNameShow: function () {
      let orgName = this.$i18n.messages[this.$i18n.locale].m.platform_name
      let platformName = this.$store.state.systemConfig['paas_platform_name']
      if (platformName) {
        document.title = platformName
      } else {
        document.title = orgName
      }
      if (
        this.$store.state.title &&
        this.$store.state.title !== '' &&
        this.$store.state.title != null &&
        this.$store.state.title !== 'null'
      ) {
        orgName = this.$store.state.title
      } else if (
        this.orgName &&
        this.orgName !== '' &&
        this.orgName !== null &&
        this.orgName !== 'null' &&
        this.orgName !== 'undefined'
      ) {
        orgName = this.orgName
      } else if (platformName) {
        orgName = platformName
      }
      return orgName
    },
    orgLogo: function () {
      let logoPath = './images/logo.png'
      // if (this.$store.state.systemConfig['paas_platform_logo_path']) {
      //   logoPath =
      //     this.$store.state.gateway_url +
      //     '/fs/media' +
      //     this.$store.state.systemConfig['paas_platform_logo_path']
      // }
      return logoPath
    }
  },
  methods: {
    getQueryVariable (variable) {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] === variable) {
          return pair[1]
        }
      }
      return false
    },
    showLogin () {
      window.location.href = this.$store.state.login_url + '/tweb/pa/login.html'
    },
    getAppMenuList (val) {
      this.activeAppName = val
      for (let a of this.$store.state.typeOfAppList) {
        if (a.appName === val) {
          this.getMenutype = 1
          this.getDocMenu(a.appId)
        }
      }
    },
    getDocMenu (id) {
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', {
          lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
          appId: id
        })
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            if (id) {
              let menuList3th = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '3'
              })
              let menuList4th = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '4'
              })
              menuList3th.map((item) => {
                this.$set(item, 'children', [])
                menuList4th.map((item1) => {
                  if (item.menuId === item1.parentMenuId) {
                    item.children.push(item1)
                  }
                })
              })
              this.$store.commit('changeMenuList3th', menuList3th)
            }
          } else {
            this.$message.error(res.data.serverResult.resultMessage)
          }
        })
    },
    filterApp (key) {
      let typeList = this.appList.filter((item) => {
        return item.type === key
      })
      this.$store.commit('changeTypeOfAppList', typeList)
      this.getAppoflist(typeList[0].appId)
    },
    getAppList () {
      this.axios
        .post('/openapi-uc/app/list', {
          appId: '',
          numPerPage: 999,
          pageNum: 1,
          pageNo: 1,
          osType: '1',
          status: '6',
          userType: '1',
          appName: '',
          sectionId: '',
          subjectId: '',
          type: ''
        })
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            this.appList = res.data.pageInfo.list
            let appType = utils.get('appType')
            let appId = utils.get('appID')
            this.axios
              .post('/openapi-uc/docMenu/queryDocMenuById/', {
                lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
                appId: appId
              })
              .then((res) => {
                if (res.data.serverResult.resultCode === '200') {
                  console.log('22222222222222222222222')
                  if (
                    res.data &&
                    res.data.pageInfo &&
                    res.data.pageInfo.list &&
                    res.data.pageInfo.list.length > 0
                  ) {
                    if (appId) {
                      let menuList3th = res.data.pageInfo.list.filter(
                        (item) => {
                          return item.menuClass === '3'
                        }
                      )
                      let menuList4th = []
                      if (menuList3th.length === 0) {
                        menuList4th = res.data.pageInfo.list.filter((item) => {
                          return item.menuClass === '4'
                        })
                      } else {
                        menuList4th = this.formatToTree(
                          res.data.pageInfo.list,
                          menuList3th[0].parentMenuId
                        )
                      }

                      this.$store.commit('changeMenuList3th', menuList4th)
                      this.$store.commit('changeActiveAppId', appId)
                      this.$store.commit('changeMenuId', menuList4th[0].menuId)
                    } else {
                      this.$store.commit('hasDoc', false)
                    }
                  } else {
                    this.$store.commit('hasDoc', false)
                    this.$store.commit('changeMenuList3th', [])
                    this.$store.commit('changeMenuId', '')
                  }
                } else {
                  this.$message.error(res.data.serverResult.resultMessage)
                }
              })
            this.filterApp(appType || '1')
          } else {
            this.$message.warning('找不到app数据')
          }
        })
    },
    getAppoflist (appId) {
      let data = {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        appId: this.$store.state.typeOfAppList[0].appId
      }
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', data)
        .then((res) => {
          if (
            res.data.serverResult.resultCode === '200' &&
            res.data.pageInfo.list.length > 0
          ) {
            if (appId) {
              let menuList = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '2'
              })
              if (menuList.length === 0) {
                let menuList3th = res.data.pageInfo.list.filter((item) => {
                  return item.menuClass === '3'
                })
                let menuList4th = this.formatToTree(
                  res.data.pageInfo.list,
                  menuList3th[0].parentMenuId
                )

                this.$store.commit('changeMenuList3th', menuList4th)
                if (this.$store.state.MenuList3th[0].menuClass === '3') {
                  this.$store.commit(
                    'changeMenuId',
                    menuList3th[0].children[0].menuId
                  )
                } else {
                  this.$store.commit('changeMenuId', menuList4th[0].menuId)
                }
              } else {
                this.$store.commit('changeMenuList2th', menuList)
              }
            } else {
              let menuList = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '1'
              })
              let tempArr = JSON.parse(JSON.stringify(menuList))
              this.menuList = tempArr
              this.getMenuList(menuList[0].menuId)
            }
          } else {
            this.$store.commit('changeMenuList3th', [])
          }
        })
    },
    formatToTree (ary, pid) {
      return ary
        .filter((item) =>
          // 如果没有父id（第一次递归的时候）将所有父级查询出来
          // 这里认为 item.parentId === 0 就是最顶层 需要根据业务调整
          pid === undefined
            ? item.parentMenuId === '0'
            : item.parentMenuId === pid
        )
        .map((item) => {
          // 通过父节点ID查询所有子节点
          item.children = this.formatToTree(ary, item.menuId)
          return item
        })
    },
    // 路由导航
    routerTo (data) {
      let path = utils.get('routePath')
      if (path === null || path === '/introduce/scene') {
        this.getMenuList(this.menuList[0].menuId)
      } else {
        //
        for (let a of data) {
          if (a.menuPath === path) {
            if (path === '/integrate/faq/apiQuestion') {
              this.getMenuList('TWPAAS11000000002')
              setTimeout(() => {
                this.$store.commit('changeActiveId2th', 'TWPAAS11000000010')
                this.getMenu3THList('TWPAAS11000000010')
              }, 200)
            } else if (path === '/integrate/quick/account') {
              this.getMenuList('TWPAAS11000000002')
            } else if (path === '/integrate/api/readme') {
              this.getMenuList('TWPAAS11000000002')
              setTimeout(() => {
                this.$store.commit('changeActiveId2th', 'TWPAAS11000000009')
                this.getMenu3THList('TWPAAS11000000009')
              }, 200)
            }
            setTimeout(() => {
              this.$store.commit('changeMenuId', a.menuId)
            }, 400)
            utils.set('nowMenuId', a.menuId)
          }
        }
      }
    },
    getMenu3THList (menuId) {
      this.activeMenuId = menuId
      let data = {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        menuId: menuId
      }
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', data)
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            if (menuId) {
              let menuList3th = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '3'
              })
              let menuList4th = []
              if (menuList3th.length === 0) {
                menuList4th = res.data.pageInfo.list.filter((item) => {
                  return item.menuClass === '4'
                })
              } else {
                menuList4th = this.formatToTree(
                  res.data.pageInfo.list,
                  menuList3th[0].parentMenuId
                )
              }
              this.$store.commit('changeMenuList3th', menuList4th)
            }
          } else {
            this.$message.error(res.data.serverResult.resultMessage)
          }
        })
    },
    getMenuList (menuId) {
      this.showMenuLis = null
      this.activeMenuId = menuId
      let data = {
        lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
        menuId: menuId
      }
      if (menuId === 'TWPAAS11000000004') {
        this.getAppList()
      }
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', data)
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            this.$store.commit('changePageName', 'Doc')
            this.$store.commit('changeMenuList2th', [])
            this.$store.commit('changeTypeOfAppList', [])
            if (menuId) {
              let menuList = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '2'
              })
              if (menuList.length > 0) {
                this.$store.commit('changeActiveId2th', menuList[0].menuId)
              }
              if (menuList.length === 0) {
                let menuList3th = res.data.pageInfo.list.filter((item) => {
                  return item.menuClass === '3'
                })
                let menuList4th = []
                if (menuList3th.length === 0) {
                  menuList4th = res.data.pageInfo.list.filter((item) => {
                    return item.menuClass === '4'
                  })
                } else {
                  menuList4th = this.formatToTree(
                    res.data.pageInfo.list,
                    menuList3th[0].parentMenuId
                  )
                }
                this.$store.commit('changeMenuList3th', menuList4th)
                // 默认打开第一个选项
                if (
                  this.$store.state.MenuList3th[0] &&
                  this.$store.state.MenuList3th[0].menuClass === '3'
                ) {
                  this.$store.commit(
                    'changeMenuId',
                    menuList4th[0].children[0].menuId
                  )
                  this.$store.commit('hasDoc', true)
                } else {
                  this.$store.commit('changeMenuId', menuList4th[0].menuId)
                  this.$store.commit('hasDoc', true)
                }
              } else {
                this.$store.commit('changeMenuList2th', menuList)
                this.getMenu3THList(menuId)
                this.$store.commit('changeMenuId', menuList[0].menuId)
                this.$store.commit('hasDoc', true)
              }
            } else {
              let menuList = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '1'
              })
              let tempArr = JSON.parse(JSON.stringify(menuList))
              this.menuList = tempArr
              this.routerTo(res.data.pageInfo.list)
            }
            this.showMenuLis = setTimeout(() => {
              this.isShowMenuLis = true
              clearTimeout(this.showMenuLis)
            }, 200)
          } else {
            this.$message.error(res.data.serverResult.resultMessage)
          }
        })
    },
    classification () {
      let appTypeList = []
      if (this.$store.state.MenuList2th.length > 0) {
        let type = this.$store.state.MenuList2th[0].appType
        for (let a of this.appTypeDocList) {
          if ((a.type = type)) {
            appTypeList.push(a)
          }
        }
      }
    },
    getMenuList3th (menuId) {
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', {
          lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
          menuId: menuId
        })
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            if (menuId) {
              let menuList3th = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '3'
              })
              let menuList4th = res.data.pageInfo.list.filter((item) => {
                return item.menuClass === '4'
              })
              menuList3th.map((item) => {
                this.$set(item, 'children', [])
                menuList4th.map((item1) => {
                  if (item.menuId === item1.parentMenuId) {
                    item.children.push(item1)
                  }
                })
              })
              this.$store.commit('hasDoc', true)
              this.$store.commit('changeMenuList3th', menuList3th)
              this.$store.commit(
                'changeMenuId',
                menuList3th[0].children[0].menuId
              )
            }
          } else {
            this.$message.error(res.data.serverResult.resultMessage)
          }
        })
    },
    goto () {
      this.$store.commit('changePageName', 'dicMenu')
    },
    jumpTo (index) {
      let linkList = [
        'http://192.168.102.109:7780/unified-portal/doc.html#/default/',
        'http://192.168.112.179:83/#/doc/comps/poppane'
      ]
      window.open(linkList[index])
    },
    showUserImage: function () {
      let vm = this
      vm.orgName = utils.get('CURRENT_ORG_NAME')
      vm.username = utils.get('CURRENT_LOGIN_NAME')
      vm.showUserImg = true
    },
    isIEBelow9: function () {
      let userAgent = navigator.userAgent
      let isIE =
        userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
      let isEdge = userAgent.indexOf('Edge') > -1 && !isIE
      let isIE11 =
        userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
      if (isIE) {
        let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
        reIE.test(userAgent)
        let fIEVersion = parseFloat(RegExp['$1'])
        if (fIEVersion === 7) {
          return true
        } else if (fIEVersion === 8) {
          return true
        } else if (fIEVersion === 9) {
          return true
        } else if (fIEVersion === 10) {
          return false
        } else {
          return true
        }
      } else if (isEdge) {
        return false
      } else if (isIE11) {
        return false
      } else {
        // 非 IE 浏览器
        return false
      }
    },
    getUserToLogin: function (accessToken) {
      let vm = this
      let state = vm.$store.state
      let loginUser = vm.user
      this.axios
        .get('/openapi-uc/uc/getUserByToken/' + accessToken)
        .then(function (response) {
          let user = response.data.responseEntity
          console.log(user, 57111)
          if (user) {
            if (user.user2OrgList && user.user2OrgList.length > 0) {
              let tenantId = user.user2OrgList[0].tenantId
              state.tenantId = tenantId
              utils.set('CURRENT_TENANT_ID', tenantId)
            }
            state.roleIdList = user.roleIdList
            utils.set('CURRENT_ROLE_ID_LIST', user.roleIdList)
            let onepicelist = [
              '1000000002',
              '1000000003',
              '1000000004',
              '1000000008',
              '10000000030'
            ]
            for (let a of onepicelist) {
              for (let b of user.roleIdList) {
                if (a === b) {
                  utils.set('CURRENT_ROLE_ID', b)
                }
              }
            }
            state.userId = user.userId
            utils.set('Current_User_Id', user.userId)
            utils.set('X-User-Account', user.userId)
            state.userName = user.realName
            utils.set('CURRENT_LOGIN_NAME', user.realName)
            state.orgId = user.orgId
            utils.set('Current-Org-Id', user.orgId)
            state.orgName = user.orgName
            utils.set('CURRENT_ORG_NAME', user.orgName)
            loginUser.userId = state.userId
            loginUser.userName = state.userName
            loginUser.orgId = state.orgId
            loginUser.orgName = state.orgName
            vm.showUserImage()
            utils.set('user', JSON.stringify(user))
            // 加路由
          }
          vm.dialogLogin = false
          window.location.href = ''
        })
        .catch(function (error) {
          vm.showCaptcha = true
          vm.$message({
            message: error,
            type: 'error'
          })
        })
    },
    userLogin: function () {
      let vm = this
      let accessToken = this.$route.query.access_token
      let accreditCode = this.$route.query.accredit_code
      let userRoleIdList = []
      if (utils.get('CURRENT_ROLE_ID_LIST') !== null) {
        userRoleIdList = utils.get('CURRENT_ROLE_ID_LIST')
        if (userRoleIdList.indexOf('1000000001') >= 0) {
          vm.showDocMMneu = true
        } else {
          vm.showDocMMneu = false
        }
      }
      if (this.$route.path !== '/') {
        vm.routePath = this.$route.path
        utils.set('routePath', this.$route.path)
      }

      if (accessToken === undefined || accreditCode === undefined) {
        return
      }
      // let appInfo = {}
      let loginParam =
        'client_id=50f104a9932e412cba81a0224d78bc92&client_secret=' +
        vm.$store.state.client_secret +
        '&grant_type=client_credentials&accredit_code=' +
        accreditCode +
        '&access_token=' +
        accessToken
      vm.axios
        .post('/openapi-uc/oauth/token?' + loginParam, {}, headConfig)
        .then(function (response) {
          if (response.data.resultCode === '8006') {
            vm.weakPwdFlag = true
            vm.$store.commit('weakPwdFlag', true)
            utils.set('weakPwdFlag', true)
          }
          let accessToken = response.data.access_token
          utils.set('Access-Token', accessToken)
          vm.getUserToLogin(accessToken)
        })
        .catch(function (error) {
          let msg = null
          if (error.errorCode === 8005) {
            vm.orgList = []
            vm.userId = null
            let userList =
              error.userList != null ? error.userList : error.exception.userList
            for (let i = 0; i < userList.length; i++) {
              let u = userList[i]
              if (u.userId.startsWith('CJTWBS1')) {
                continue
              }
              let orgObject = {}
              let roleName = ''
              let orgName = ''
              let realName = ''
              if (u.roleName) {
                roleName = u.roleName
              }
              if (u.orgName) {
                orgName = u.orgName
              }
              if (u.realName) {
                realName = u.realName
              }

              orgObject.orgUserName = orgName + '(' + realName + roleName + ')'
              orgObject.userId = u.userId
              vm.orgList.push(orgObject)
              if (i === 0) {
                vm.userId = u.userId
                vm.username = realName
              }
            }
            if (vm.orgList.length === 1) {
              vm.userId = vm.orgList[0].userId
              vm.login()
              return
            }
            vm.chooseOrg = true
            msg = vm.$i18n.messages[vm.$i18n.locale].m.loginNameRepeatTip
          } else if (error.errorCode === 8001) {
            msg = vm.$i18n.messages[vm.$i18n.locale].m.userStatusNotCorrectTip
          } else if (error.errorCode === 8002) {
            msg = vm.$i18n.messages[vm.$i18n.locale].m.userNotExistTip
          } else if (error.errorCode === 8004) {
            msg = error.errorMesage
          } else if (error.errorCode === 8007) {
            msg = error.errorMesage
          } else if (error.errorCode === 8000) {
            msg = error.errorMesage
          } else if (error.errorCode === 70008) {
            msg = error.errorMesage
          } else {
            msg = vm.$i18n.messages[vm.$i18n.locale].m.loginFailed
          }
          vm.$message({
            message: msg,
            type: 'error'
          })
        })
    },
    logout: function () {
      let vm = this
      let state = vm.$store.state
      state.token = ''
      state.tenantId = ''
      state.userId = ''
      state.userName = ''
      state.orgId = ''
      state.orgName = ''
      state.lang = ''
      utils.delete('Access-Token')
      utils.delete('CURRENT_TENANT_ID')
      utils.delete('CURRENT_ROLE_ID_LIST')
      utils.delete('Current_User_Id')
      utils.delete('CURRENT_LOGIN_NAME')
      utils.delete('Current-Org-Id')
      utils.delete('CURRENT_ORG_NAME')
      utils.delete('SWITCH_LANG')
      utils.delete('routePath')
      utils.delete('appID')
      utils.delete('appType')
      vm.showUserImg = false
      let currentUrl = window.location.href
      let index = currentUrl.indexOf('?')
      if (index >= 0) {
        currentUrl = currentUrl.substr(0, index)
      }
      this.$router.go(0)
      state.editor.isAdmin = false
      state.editor.isEditing = false
      window.location.href = currentUrl
    }
  },
  created: function () {
    let vm = this
    let userId = utils.get('Current_User_Id')
    if (userId) {
      vm.showUserImage()
    }
    vm.axios
      .post('/openapi-uc/system/platConfig', {})
      .then(function (success) {
        if (
          success.data &&
          success.data.pageInfo &&
          success.data.pageInfo.list
        ) {
          let list = success.data.pageInfo.list
          let systemConfigMap = {}
          list.forEach(function (item) {
            if (item.value) {
              systemConfigMap[item.key] = item.value
            }
          })
          vm.$store.commit('systemConfig', systemConfigMap)
        }
      })
      .catch(function (error) {
        vm.$message({
          message: error.data.serverResult.resultMessage,
          type: 'error'
        })
      })
    this.getMenuList('')
  },
  mounted: function () {
    let appType = this.$route.query.apptype || this.$route.query.appType
    let appId = this.$route.query.appid || this.$route.query.appId
    if (appType !== undefined && appId !== undefined) {
      console.log(appType, appId, 'appType')
      utils.set('appID', appId)
      utils.set('appType', appType)
    }
    this.userLogin()
    setTimeout(() => {
      if (utils.get('appID') !== null && utils.get('appType') !== null) {
        this.getMenuList('TWPAAS11000000004')
      }
    }, 500)
  }
}
</script>
<style scoped>
.xbutton-color {
  color: #adb9d2;
}
.xactice-color {
  color: #0088ff;
}
.xbutton-color :hover {
  color: #0088ff;
}
.xrouter {
  color: #adb9d2;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// tw-header.vue?8c1adb6c